import NavbarThree from "../../components/NavbarThree";
import MediaButtonsOrange from "src/components/MediaButtonsOrange";
import Footer from "../../components/Footer";
import ButtonTop from "src/components/ButtonTop";

import SectionOne from "./components/sectionOne";
import SectionTwo from "./components/sectionTwo";
import SectionThree from "./components/sectionThree";
import SectionFour from "./components/sectionFour";
import SectionFive from "./components/sectionFive";
import SectionSix from "./components/sectionSix";
import SectionExtra from "./components/sectionExtra";
import SectionSeven from "./components/sectionSeven";
/* import { useEffect } from "react"; */

function LandingPageThree() {
  
  /* useEffect(() => {
  // Widget Tallos
  if (!document.getElementById("tallos-widget")) {
    const script = document.createElement("script");
    script.src =
      "https://api.tallos.com.br/megasac-api/widget/6929c01e257fe3576438262a--1.min.js";
    script.async = true;
    script.id = "tallos-widget";

    document.body.appendChild(script);
  }

  // RD Station
  if (!document.getElementById("rdstation-script")) {
    const rdScript = document.createElement("script");
    rdScript.src =
      "https://d335luupugsy2.cloudfront.net/js/loader-scripts/3c4e990d-bb4d-4220-87f0-08b12be0125b-loader.js";
    rdScript.async = true;
    rdScript.id = "rdstation-script";

    document.body.appendChild(rdScript);
  }
}, []); */

  return (
    <div id="landingPageThree">
      {/* LANDINGPAGE ARMAZEM */}
      <NavbarThree></NavbarThree>
      <MediaButtonsOrange message="Olá, vim pelo site de Armazenagem e gostaria de falar com um especialista de logística da GH."></MediaButtonsOrange>
      <ButtonTop></ButtonTop>
      <SectionOne id="home" message="Olá, vim pelo site de Armazenagem e gostaria de falar com um especialista de logística da GH."></SectionOne>
      <SectionTwo id="services"></SectionTwo>
      <SectionThree id="map"></SectionThree>
      <SectionExtra></SectionExtra>
      <SectionFour id="operations"></SectionFour>
      <SectionFive id="feedback"></SectionFive>
      <SectionSix id="licenses"></SectionSix>
      <SectionSeven></SectionSeven>
      <Footer></Footer>
    </div>
  );
}

export default LandingPageThree;
